<template>
  <!-- 待学习 -->
  <div class="publicCourses">
    <van-nav-bar :title="'公共课程'" left-text left-arrow @click-left="onClickLeft" @click-right="onClickRight"
      :fixed="true" />
    <div class="fixedH" style="height: 1.22667rem"></div>
    <van-search v-model="searchVal" placeholder="请输入搜索关键词" @input="onSearch" :class="'fefefefef2'" />
    <div class="fixedH" style="height: 1.35rem"></div>
    <div class="tj">
      <div @click="openNyr" class="openNyr">
        {{ treevalue }}
        <svg-icon icon-class="jxEvaluationRecordPBtn black"></svg-icon>
      </div>
      <div class="tabbox">
        <div v-for="(e, index) in tab" :key="index" :class="{ tabbbb: true, cus: study_status == e.study_status }"
          @click="clicktab(e)">
          {{ e.lable }}<span v-if="e.num">({{ e.num }})</span>
        </div>
      </div>
    </div>
    <div class="fixedH" style="height: 1rem"></div>

    <div class="van-list">
      <van-cell v-for="(value, index) in list" :key="index" class="examList" @click="examinInfo(value, index)">
        <div class="list_va">
          <div class="left-img">
            <img :style="value.csurl ? 'object-fit: contain;' : ''" alt v-lazy="value.csurl
                ? value.csurl
                : require('@/assets/img/dwedewweddw.png')
              " />
          </div>
          <div class="info">
            <!-- <div class="infoExamIcon" v-if="value.study_status == 2">
              <img src="@/assets/img/toExamined-end.png" alt />
            </div> -->
            <div class="toptop">
              <span class="courseName">{{ value.coursename }}</span>
            </div>
            <div v-if="value.custom_field1" class="html_box" v-html="value.custom_field1"></div>
            <div v-if="value.custom_field2" class="html_box" v-html="value.custom_field2"></div>
            <div class="footer">
              <div>
                <span class="time" v-if="value.study_pg_title">
                  {{ value.study_pg_title }}
                  {{ value.study_pg }}
                </span>
              </div>
              <div>
                <span v-if="value.study_status == 0" class="study_status" style="color:#999;">未开始</span>
                <span v-if="value.study_status == 1" class="study_status" style="color:#2B8DF0;">学习中</span>
                <span v-if="value.study_status == 2" class="study_status" style="color:#35B15E;">已完成</span>
              </div>
            </div>
          </div>
        </div>
      </van-cell>
    </div>
    <!-- 右侧弹出 -->
    <van-popup v-model="showPicker" position="right" :style="{ width: '90%', height: '100%', background: '#EEEEEE' }">
      <van-cell title="全部分类" class="lever1" @click="setTree('全部课程')" />
      <van-collapse v-model="activeNames">
        <van-collapse-item :title="t1.keyname" :name="t1.autoid" v-for="t1 in treeList" :key="t1.autoid" class="lever1">
          <template #title>
            <div @click="t1.children.length == 0 && setTree(t1.keyname)">
              {{ t1.keyname }}
            </div>
          </template>
          <van-collapse v-model="activeNames2">
            <van-collapse-item :title="t2.keyname" :name="t2.autoid" v-for="t2 in t1.children" :key="t2.autoid"
              class="lever2">
              <template #title>
                <div @click="t2.children.length == 0 && setTree(t2.keyname,t1.keyname)">
                  {{ t2.keyname }}
                </div>
              </template>
              <template #right-icon v-if="t2.children.length == 0">
                <!-- <van-icon name="arrow" /> -->
                <div></div>
              </template>
              <van-collapse v-model="activeNames3">
                <van-collapse-item :title="t3.keyname" :name="t3.autoid" v-for="t3 in t2.children" :key="t3.autoid"
                  class="lever3">
                  <template #title>
                    <div @click="setTree(t3.keyname,t2.keyname)">
                      {{ t3.keyname }}
                    </div>
                  </template>
                  <template #right-icon v-if="t3.children.length == 0">
                    <!-- <van-icon name="arrow" /> -->
                    <div></div>
                  </template>
                  <van-collapse v-model="activeNames4">
                    <van-collapse-item :title="t4.keyname" :name="t4.autoid" v-for="t4 in t3.children" :key="t4.autoid"
                      class="lever3">
                      <template #title>
                        <div @click="setTree(t4.keyname,t3.keyname)">
                          {{ t4.keyname }}
                        </div>
                      </template>
                      <template #right-icon v-if="t4.children.length == 0">
                        <!-- <van-icon name="arrow" /> -->
                        <div></div>
                      </template>
                      <van-collapse v-model="activeNames4">
                        <van-collapse-item :title="t5.keyname" :name="t5.autoid" v-for="t5 in t4.children"
                          :key="t5.autoid" class="lever3">
                          <template #title>
                            <div @click="setTree(t5.keyname,t4.keyname)">
                              {{ t5.keyname }}
                            </div>
                          </template>
                          <template #right-icon>
                            <!-- <van-icon name="arrow" /> -->
                            <div></div>
                          </template>
                        </van-collapse-item>
                      </van-collapse>
                    </van-collapse-item>
                  </van-collapse>
                </van-collapse-item>
              </van-collapse>
            </van-collapse-item>
          </van-collapse>
        </van-collapse-item> </van-collapse></van-popup>
  </div>
</template>

<script>
const userInfo = localStorage.userInfo ? JSON.parse(localStorage.userInfo) : {}
import { getCommTreeData } from '@api/wxjx.js'
import { getStudyCourseList } from '@api/wxpx.js'
export default {
  data() {
    return {
      userInfo,
      isLoading: false,
      activeNames: [],
      activeNames2: [],
      activeNames3: [],
      activeNames4: [],
      activeNames5: [],
      list: [],
      oplist: [],
      loading: false,
      finished: false,
      showPicker: false,
      ispts: this.$route.query.ispts,
      titleText: this.$route.query.text || '',
      searchVal: '',
      treevalue: '全部课程',
      treevalue2: '',
      tabvalue: '',
      trainsourcelist: [],
      study_status: null,
      tab: [
        {
          study_status: 0,
          lable: '未完成',
          num: 0
        },
        {
          study_status: 1,
          lable: '学习中',
          num: 0
        },
        {
          study_status: 2,
          lable: '已完成',
          num: 0
        }
      ],
      sxType: '',
      treeList: [],
      appScrollTop: 0
    }
  },
  // watch: {
  //   // 监听整个路由对象的变化
  //   '$route'(to, from) {
  //     if (to.path == '/publicCourses' && from.path == '/learningCourses') {
  //       this.$nextTick(()=>{
  //         if (document.getElementById("app")) {
  //           document.getElementById("app").scrollTop = this.appScrollTop;
  //           this.onLoad();
  //         }
  //       })
  //     }
  //   }
  // },
  beforeRouteLeave(to, from, next) {
    if (to.path.indexOf('learningCourses') != -1) {
      if (document.getElementById("app")) {
        const appScrollTop = document.getElementById("app").scrollTop;
        sessionStorage.setItem("learningCoursesAppScrollTop", appScrollTop);
      }
    }
    next();
  },
  created() {

    this.onLoad();

  },
  methods: {
    // 重置页面状态
    reloadData() {
      this.$nextTick(() => {
        let appScrollTop = sessionStorage.getItem("learningCoursesAppScrollTop");
        let learningCoursesSearchVal = sessionStorage.getItem("learningCoursesSearchVal");
        let learningCoursesTreeValue = sessionStorage.getItem("learningCoursesTreeValue");
        let learningCoursesStudyStatus = sessionStorage.getItem("learningCoursesStudyStatus");
        if (document.getElementById("app") && appScrollTop) {
          document.getElementById("app").scrollTop = appScrollTop ? Number(appScrollTop) : 0;
        }
        this.searchVal = learningCoursesSearchVal ? learningCoursesSearchVal : "";
        this.treevalue = learningCoursesTreeValue ? learningCoursesTreeValue : "全部课程";
        this.study_status = learningCoursesStudyStatus ? learningCoursesStudyStatus : null;
        
        if (this.treevalue && this.treevalue != '全部课程') {
          this.setTree(this.treevalue)
        } else {
          if (this.searchVal || this.study_status) {
            this.onSearch()
          }
        }
      })
    },
    setTree(v,v2='') {
      console.log(v,v2,'setTree');
      
      this.treevalue = v;
      this.treevalue2 = v2;
      sessionStorage.setItem("learningCoursesTreeValue", this.treevalue);
      this.showPicker = false
      this.onSearch()
    },
    // 搜索
    onSearch() {
      sessionStorage.setItem("learningCoursesSearchVal", this.searchVal);
      let arr = JSON.parse(JSON.stringify(this.oplist))

      if (this.treevalue != '全部课程') {
        arr = arr.filter(item => {
          return item.coursetype == this.treevalue && (item.parent_coursetype == this.treevalue2 ||  this.treevalue2=='')
        })
      }

      if (this.study_status != null) {
        arr = arr.filter(item => {
          return item.study_status == this.study_status
        })
      }

      if (this.searchVal) {
        arr = arr.filter(item => {
          return item.coursename.indexOf(this.searchVal) != -1
        })
      }
      this.tab.forEach(e => {
        e.num = 0
      })
      arr.forEach(e => {
        this.tab[e.study_status].num++
      })
      this.list = arr
    },
    examinInfo(item, key) {
      // item.ispts=true
      window.sessionStorage.setItem('v8_study_data', JSON.stringify(item))
      window.localStorage.setItem('learningCoursesDataKey' + item.autoid, 0)
      window.localStorage.setItem('learningCoursesDataIndex' + item.autoid, 0)
      // 跳转网址
      const u = navigator.userAgent
      const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
      if (isAndroid) {
        this.$router.push({
          path: '/learningCoursesAndroid',
          query: {
            mautoid: item.autoid
          }
        })
      } else if (isiOS) {
        this.$router.push({
          path: '/learningCourses',
          query: {
            mautoid: item.autoid
          }
        })
      } else {
        this.$router.push({
          path: '/learningCourses',
          query: {
            mautoid: item.autoid
          }
        })
      }
    },
    onClickLeft() {

      if (window.CloundEntid == '115') {
        window.location.href = 'http://hyclound.cn/hgvis_115_h5/pc2022_5.html'
      } else {
        this.$router.push('/home')
      }
    },
    onClickRight() { },
    onLoad() {
      getStudyCourseList({
        empid: this.userInfo.empid,
        ispts: this.ispts == 0 ? false : true,
        trainsource: this.sxType
      }).then(res => {
        if (res.iserror == 0) {
          this.tab.forEach(e => {
            e.num = 0
          })
          res.data.forEach(e => {
            if (e.study_status == 0) {
              this.tab[0].num++
            } else if (e.study_status == 1) {
              this.tab[1].num++
            } else if (e.study_status == 2) {
              this.tab[2].num++
            }
          })
          this.list = res.data
          this.oplist = JSON.parse(JSON.stringify(res.data))
          this.loading = false
          this.finished = true
          this.trainsourcelist = res.trainsourcelist
        }
        this.reloadData();
      })
    },
    openNyr() {
      this.showPicker = true
      this.getCommTree()
    },
    clicktab(v) {
      if (this.study_status == v.study_status) {
        this.study_status = null
        sessionStorage.setItem("learningCoursesStudyStatus", "");
      } else {
        this.study_status = v.study_status;
        sessionStorage.setItem("learningCoursesStudyStatus", String(this.study_status));
      }
      this.onSearch()
    },
    // 获取通用树
    async getCommTree() {
      await getCommTreeData({
        moduleno: 201,
        treename: 'ptstypetree', // 树名
        username: this.userInfo.username,
        fieldname: '',
        editstate: 3,
        formstr: ''
      }).then(res => {
        let list = res.data || []
        // 只需要1,2,3,4,5级数据
        list = list.filter(it => {
          return it.levelid > 0 && it.levelid < 6
        })
        let map = {},
          node,
          tree = [],
          i
        for (i = 0; i < list.length; i++) {
          list[i].activeNames2 = []
          if (list[i].parentid == 1) {
            list[i].parentid = null
          }
          map[list[i].autoid] = i // 初始化映射
          if (list[i].levelid != 6) {
            list[i].children = [] // 初始化children数组
          }
        }
        for (i = 0; i < list.length; i++) {
          node = list[i]
          if (node.parentid !== null) {
            // 如果当前节点有父节点，则找到父节点的位置并将当前节点添加到父节点的children数组中
            list[map[node.parentid]].children.push(node)
          } else {
            // 如果当前节点没有父节点，则将其添加到树的顶层
            tree.push(node)
          }
        }
        this.treeList = tree
        console.log(this.treeList, 'this.treeList ')
      })
    }
  }
}
</script>

<style lang="less" scoped>
.fefefefef2 {
  position: fixed;
  left: 0;
  top: 1.22667rem;
  z-index: 999;
  width: 100%;
  padding: 0.1rem 0.32rem 0.2rem !important;
}

.tj {
  position: fixed;
  left: 0;
  top: 2.37667rem;
  z-index: 999;
  width: 100%;
  padding: 0.1rem 0.32rem 0.2rem !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f6f6f6;

  .openNyr {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    font-size: 34px;
    color: #333333;
    cursor: pointer;
  }

  .tabbox {
    width: 65%;
    display: flex;
    justify-content: space-between;
    padding-right: 10px;
    align-items: center;
    height: 100%;

    .tabbbb {
      cursor: pointer;
      color: #999999;
      border-radius: 3px 3px 3px 3px;
      padding: 10px;
      font-size: 28px;
    }

    .tabbbb.cus {
      color: #2b8df0;
      background: #e4f1ff;
    }
  }
}

.publicCourses {
  .van-nav-bar {
    background: #2b8df0;

    /deep/ .van-nav-bar__left {
      .van-icon {
        color: #fff;
      }
    }

    /deep/.van-nav-bar__title {
      color: #fff;
      font-size: 36px;
      font-family: Source Han Sans CN;
    }

    ::v-deep .van-nav-bar__right {
      .van-nav-bar__text {
        color: #fff;
        font-family: Source Han Sans CN;
      }
    }
  }

  .examList {
    padding: 0 !important;
    margin: 0 10px 30px 10px !important;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.1);
    border-radius: 20px;
    width: calc(100% - 20px);

    .van-cell__value {
      .list_no {
        padding: 0 20px;
        margin-bottom: 20px;
        font-size: 24px;
        color: #666666;
        line-height: 64px;
        word-break: break-all;
        background: linear-gradient(90deg,
            rgba(25, 137, 250, 0) 0%,
            rgba(25, 137, 250, 0.5) 0%,
            rgba(25, 137, 250, 0) 100%);
      }

      .list_va {
        display: flex;
        align-items: center;
        padding: 10px 10px 10px 10px;

        .left-img {
          position: relative;
          width: 282px;
          height: 183px;
          overflow: visible;
          background: #ecf2ff;
          opacity: 1;
          margin: 15px;
          text-align: center;
          // margin-right: 18px;
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            width: 100%;
            display: block;
            height: 100% !important;
            border-radius: 20px;
          }
        }
      }

      .info {
        flex: 1;
        position: relative;
        width: calc(100% - 330px);
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        // height: 160px;
        min-height: 160px;

        .infoExamIcon {
          position: absolute;
          right: 10%;
          top: 10%;
          z-index: 0;
          width: 130px;
          opacity: 0.5;

          /* 设置为50%透明度 */
          img {
            width: 130px;
          }
        }

        .lecturerName {
          font-weight: 500;
          font-size: 20px;
          color: #333333;
          font-family: Source Han Sans CN;
        }

        .toptop {
          display: flex;
          justify-content: space-between;
          align-items: baseline;

          .courseName {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            width: 100%;
            line-height: 1.1;
            margin: 0;
            font-size: 30px;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #333333;
          }

          .right {
            .score {
              font-size: 30px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              line-height: 27px;
              color: #2b8df0;
            }

            .duration {
              font-size: 24px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              line-height: 27px;
              color: #333333;
            }
          }
        }

        .html_box {
          /deep/p {
            margin: 0;
          }
        }

        .time {
          color: #2b8df0;
          font-size: 20px;
          background: #e4f1ff;
          border-radius: 3px 3px 3px 3px;
          padding: 10px;
        }

        .study_status {
          font-size: 20px;
        }

        .footer {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
      }
    }
  }
}

.lever1 {
  margin-bottom: 20px;

  /deep/ .van-cell__title {
    color: #999999;
  }

  /deep/ .van-collapse-item__content {
    padding-top: 0;
    padding-bottom: 0;
  }
}

.lever2 {
  /deep/ .van-cell__title {
    color: #333;
  }
}

/deep/ .van-grid-item__content {
  background: #eeeeee;
  border-radius: 3px 3px 3px 3px;
  margin: 5px;
  height: 60px;
}
</style>
